/* Loumi Baby – ortak davranış: sepet çekmecesi (Ajax Cart API), hızlı ekle, menü, modal, toast.
   Diğer bölümler window.LM üzerinden kullanır:
     LM.cart.add([{ id: variantId, quantity: 1 }], { open: true })
     LM.openDrawer() · LM.openModal('id') · LM.closeAll() · LM.toast('metin') · LM.money(cents) · LM.delivery() */
(function () {
  'use strict';
  const CFG = window.LM_CFG || {};
  const SECTION = 'loumi-cart-drawer';
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const root = (CFG.root || '/').replace(/\/?$/, '/');

  /* ---------- para ---------- */
  function money(cents) {
    const fmt = CFG.moneyFormat || '{{amount}} TL';
    const n = (typeof cents === 'string' ? parseFloat(cents) : cents) / 100;
    const group = (v, d, t, s) => {
      const [i, f] = v.toFixed(d).split('.');
      return i.replace(/\B(?=(\d{3})+(?!\d))/g, t) + (f ? s + f : '');
    };
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (_, k) => {
      if (k === 'amount_no_decimals') return group(n, 0, ',', '.');
      if (k === 'amount_with_comma_separator') return group(n, 2, '.', ',');
      if (k === 'amount_no_decimals_with_comma_separator') return group(n, 0, '.', ',');
      if (k === 'amount_with_apostrophe_separator') return group(n, 2, "'", '.');
      return group(n, 2, ',', '.');
    });
  }

  /* ---------- otomatik öneriler (Shopify Recommendations API) ----------
     Önce tamamlayıcı (Search & Discovery), yetmezse benzer ürünler. Farklı ürün türündekiler öne alınır. */
  const recCache = {};
  function recs(pid, opts = {}) {
    const limit = opts.limit || 2;
    const skip = new Set((opts.exclude || []).map(String).concat(String(pid)));
    const get = (intent) => {
      const k = pid + intent;
      recCache[k] = recCache[k] || fetch(`${root}recommendations/products.json?product_id=${pid}&intent=${intent}&limit=10`)
        .then((r) => (r.ok ? r.json() : { products: [] })).then((j) => j.products || []).catch(() => []);
      return recCache[k];
    };
    const norm = (p) => ({ id: p.id, t: p.title, u: p.url, type: p.type || '', img: p.featured_image || (p.images && p.images[0]) || '', v: (p.variants || []).map((v) => ({ id: v.id, o: v.options, p: v.price, c: v.compare_at_price || 0, a: v.available })) });
    return get('complementary').then((a) => (a.length >= limit ? a : get('related').then((b) => a.concat(b)))).then((list) => {
      const seen = new Set();
      const out = list.map(norm).filter((p) => {
        if (seen.has(p.id) || skip.has(String(p.id)) || !p.v.some((v) => v.a)) return false;
        seen.add(p.id); return true;
      });
      if (opts.type) out.sort((x, y) => (x.type === opts.type) - (y.type === opts.type));
      return out.slice(0, limit);
    });
  }
  const imgW = (u, w) => (u ? `${u}${u.includes('?') ? '&' : '?'}width=${w}` : '');
  const escH = (s) => String(s == null ? '' : s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  function fillRecs(scope = document) {
    $$('[data-lm-recs]', scope).forEach((box) => {
      const exclude = (box.dataset.exclude || '').split(',').filter(Boolean);
      recs(box.dataset.lmRecs, { limit: +box.dataset.limit || 3, exclude, type: box.dataset.type }).then((list) => {
        if (!list.length || !box.isConnected) return;
        const items = list.map((p) => {
          const av = p.v.filter((v) => v.a);
          const one = p.v.length < 2;
          const sel = one ? '' : `<select aria-label="Seçenek: ${escH(p.t)}">${av.map((v) => `<option value="${v.id}">${escH((v.o || []).map((o) => (CFG.sizeLabels || {})[String(o).trim()] || o).join(' · '))}</option>`).join('')}</select>`;
          return `<div class="lm-upsell__item" data-lm-add-scope>
            <a href="${escH(p.u)}" tabindex="-1">${p.img ? `<img src="${escH(imgW(p.img, 120))}" alt="${escH(p.t)}" loading="lazy" width="56" height="56">` : ''}</a>
            <div><a href="${escH(p.u)}">${escH(p.t)}</a><br><b>${money(av[0].p)}</b>${sel}</div>
            <button type="button" data-lm-add="${one ? av[0].id : 'select'}">Ekle</button></div>`;
        }).join('');
        box.innerHTML = (box.dataset.title ? `<h4>${escH(box.dataset.title)}</h4>` : '') + items;
        box.hidden = false;
      });
    });
  }

  /* ---------- toast ---------- */
  let toastT;
  function toast(msg) {
    const t = $('#lm-toast');
    if (!t) return;
    t.textContent = msg;
    t.classList.add('is-on');
    clearTimeout(toastT);
    toastT = setTimeout(() => t.classList.remove('is-on'), 2400);
  }

  /* ---------- katmanlar ---------- */
  const overlay = () => $('#lm-overlay');
  function lock(on) { document.body.classList.toggle('lm-lock', on); }
  function closeAll() {
    $$('.lm-drawer.is-on, .lm-mnav.is-on, .lm-modal.is-on, [data-lm-sheet].is-on').forEach((e) => e.classList.remove('is-on'));
    overlay()?.classList.remove('is-on');
    $$('.lm-sizepop.is-on').forEach((e) => e.classList.remove('is-on'));
    lock(false);
  }
  function openLayer(el) {
    if (!el) return;
    $$('.lm-drawer.is-on, .lm-mnav.is-on, .lm-modal.is-on').forEach((e) => e !== el && e.classList.remove('is-on'));
    el.classList.add('is-on');
    if (!el.classList.contains('lm-modal')) overlay()?.classList.add('is-on');
    lock(true);
    const f = el.querySelector('[data-lm-autofocus], button, a');
    if (f) setTimeout(() => f.focus({ preventScroll: true }), 60);
  }
  function openDrawer() {
    const d = $('#lm-drawer');
    if (!d) { window.location.href = root + 'cart'; return; }
    openLayer(d);
    fillDelivery(d);
  }
  function openModal(id) { $('#lm-toast')?.classList.remove('is-on'); openLayer(document.getElementById(id)); }

  /* ---------- teslimat tarihi ---------- */
  const TR_D = ['Paz', 'Pzt', 'Sal', 'Çar', 'Per', 'Cum', 'Cmt'];
  const TR_M = ['Oca', 'Şub', 'Mar', 'Nis', 'May', 'Haz', 'Tem', 'Ağu', 'Eyl', 'Eki', 'Kas', 'Ara'];
  const isBiz = (d) => d.getDay() % 6 !== 0;
  function addBiz(d, n) { const x = new Date(d); while (n > 0) { x.setDate(x.getDate() + 1); if (isBiz(x)) n--; } return x; }
  function delivery() {
    const cutH = Number(CFG.cutoffHour ?? 15);
    const now = new Date();
    const cut = new Date(now); cut.setHours(cutH, 0, 0, 0);
    const today = isBiz(now) && now < cut;
    const ship = today ? now : addBiz(now, 1);
    const from = addBiz(ship, Number(CFG.shipMin ?? 1));
    const to = addBiz(ship, Number(CFG.shipMax ?? 3));
    const ms = cut - now;
    return {
      today, ship, from, to,
      hours: Math.floor(ms / 36e5), minutes: Math.floor((ms % 36e5) / 6e4),
      fmt: (d, withDay = true) => `${d.getDate()} ${TR_M[d.getMonth()]}${withDay ? ' ' + TR_D[d.getDay()] : ''}`,
      range() { return `${this.fmt(from, false)} – ${this.fmt(to, false)}`; },
    };
  }
  function fillDelivery(scope = document) {
    $$('[data-lm-delivery]', scope).forEach((el) => { el.textContent = delivery().range(); });
  }

  /* ---------- sepet ---------- */
  let busy = false;
  async function request(url, body) {
    const res = await fetch(root + url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    });
    const data = await res.json().catch(() => ({}));
    if (!res.ok) throw new Error(data.description || data.message || 'Bir hata oluştu, lütfen tekrar deneyin.');
    return data;
  }
  function paint(sections) {
    const html = sections && sections[SECTION];
    if (!html) return;
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const next = doc.querySelector('[data-lm-drawer-inner]');
    const cur = $('#lm-drawer [data-lm-drawer-inner]');
    if (next && cur) {
      const scroll = $('#lm-drawer .lm-drawer__body')?.scrollTop || 0;
      cur.replaceWith(next);
      const b = $('#lm-drawer .lm-drawer__body'); if (b) b.scrollTop = scroll;
    }
    const count = next?.dataset.count;
    if (count !== undefined) setCount(+count);
    fillDelivery($('#lm-drawer') || document);
    fillRecs($('#lm-drawer') || document);
  }
  function setCount(n) {
    $$('[data-lm-cart-count]').forEach((b) => { b.textContent = n; b.hidden = !n; });
  }
  function setBusy(on) { busy = on; $('#lm-drawer')?.classList.toggle('is-busy', on); }
  async function refresh() {
    const res = await fetch(`${root}?sections=${SECTION}`);
    paint(await res.json());
  }
  async function add(items, opts = {}) {
    const open = opts.open !== false;
    setBusy(true);
    try {
      await request('cart/add.js', { items });
      await refresh();
      document.dispatchEvent(new CustomEvent('lm:cart:added', { detail: { items } }));
      if (open && !$('#lm-drawer')?.classList.contains('is-on')) openDrawer();
      else toast(opts.message || 'Sepete eklendi');
      return true;
    } catch (e) { toast(e.message); return false; }
    finally { setBusy(false); }
  }
  async function change(key, quantity) {
    if (busy) return;
    setBusy(true);
    try { paint((await request('cart/change.js', { id: key, quantity, sections: SECTION })).sections); }
    catch (e) { toast(e.message); }
    finally { setBusy(false); }
  }
  async function update(body) {
    setBusy(true);
    try {
      const data = await request('cart/update.js', Object.assign({ sections: SECTION }, body));
      paint(data.sections);
      return data;
    } catch (e) { toast(e.message); return null; }
    finally { setBusy(false); }
  }
  async function applyCode(code) {
    const cur = $$('#lm-drawer [data-lm-code-remove]').map((b) => b.dataset.lmCodeRemove);
    const codes = Array.from(new Set(cur.concat(code ? [code] : []))).filter(Boolean);
    const data = await update({ discount: codes.join(',') });
    if (data && code) {
      const hit = (data.discount_codes || []).find((d) => d.code.toLowerCase() === code.toLowerCase());
      const err = $('#lm-drawer [data-lm-code-error]');
      if (hit && !hit.applicable) { if (err) err.textContent = 'Bu kod sepetinize uygulanamıyor.'; }
      else toast('İndirim kodu uygulandı');
    }
  }
  async function removeCode(code) {
    const codes = $$('#lm-drawer [data-lm-code-remove]').map((b) => b.dataset.lmCodeRemove).filter((c) => c !== code);
    await update({ discount: codes.join(',') });
  }

  /* ---------- tıklamalar ---------- */
  document.addEventListener('click', (e) => {
    const t = e.target;
    const q = (s) => t.closest(s);
    let el;
    if ((el = q('[data-lm-open-cart]'))) { e.preventDefault(); openDrawer(); return; }
    if ((el = q('[data-lm-close]'))) { e.preventDefault(); closeAll(); return; }
    if ((el = q('[data-lm-menu-open]'))) { e.preventDefault(); openLayer($('#lm-mnav')); return; }
    if ((el = q('[data-lm-modal-open]'))) { e.preventDefault(); openModal(el.dataset.lmModalOpen); return; }
    if ((el = q('[data-lm-search-toggle]'))) {
      e.preventDefault();
      const s = $('#lm-msearch'); s?.classList.toggle('is-on'); s?.querySelector('input')?.focus(); return;
    }
    if ((el = q('[data-lm-line-qty]'))) { e.preventDefault(); change(el.dataset.key, Math.max(0, +el.dataset.lmLineQty)); return; }
    if ((el = q('[data-lm-add]'))) {
      e.preventDefault(); e.stopPropagation();
      let id = el.dataset.lmAdd;
      if (id === 'select') id = el.closest('[data-lm-add-scope]')?.querySelector('select')?.value;
      if (!id) return;
      $$('.lm-sizepop.is-on').forEach((x) => x.classList.remove('is-on'));
      const inDrawer = !!el.closest('#lm-drawer');
      el.classList.add('is-loading');
      add([{ id: +id, quantity: +(el.dataset.qty || 1) }], { open: !inDrawer }).finally(() => el.classList.remove('is-loading'));
      return;
    }
    if ((el = q('[data-lm-quick]'))) {
      e.preventDefault(); e.stopPropagation();
      const pop = el.closest('.lm-card')?.querySelector('.lm-sizepop');
      const was = pop?.classList.contains('is-on');
      $$('.lm-sizepop.is-on').forEach((x) => x.classList.remove('is-on'));
      if (pop && !was) pop.classList.add('is-on');
      return;
    }
    if ((el = q('[data-lm-card-color]'))) {
      e.preventDefault();
      const card = el.closest('.lm-card');
      const c = el.dataset.lmCardColor;
      $$('[data-lm-card-color]', card).forEach((b) => b.classList.toggle('is-on', b === el));
      const img = card.querySelector('.lm-card__main');
      if (img && el.dataset.img) { img.src = el.dataset.img; img.removeAttribute('srcset'); }
      $$('.lm-sizepop__grid', card).forEach((g) => { g.hidden = g.dataset.color !== c; });
      const link = card.querySelector('.lm-card__img'); if (link && el.dataset.url) link.href = el.dataset.url;
      return;
    }
    if ((el = q('[data-lm-code-apply]'))) {
      e.preventDefault();
      const inp = el.closest('[data-lm-code]')?.querySelector('input');
      const v = inp?.value.trim(); if (v) applyCode(v); return;
    }
    if ((el = q('[data-lm-code-remove]'))) { e.preventDefault(); removeCode(el.dataset.lmCodeRemove); return; }
    if (!q('.lm-sizepop')) $$('.lm-sizepop.is-on').forEach((x) => x.classList.remove('is-on'));
  });

  document.addEventListener('change', (e) => {
    const t = e.target;
    if (t.matches('[data-lm-line-input]')) change(t.dataset.key, Math.max(0, parseInt(t.value, 10) || 0));
    if (t.matches('[data-lm-gift]')) {
      const box = t.closest('.lm-extra');
      const wrap = box?.querySelector('[data-lm-gift-note]');
      if (wrap) wrap.hidden = !t.checked;
      if (t.dataset.variant) {
        if (t.checked) add([{ id: +t.dataset.variant, quantity: 1 }], { open: false, message: 'Hediye paketi eklendi' });
        else if (t.dataset.key) change(t.dataset.key, 0);
      } else update({ attributes: { 'Hediye paketi': t.checked ? 'Evet' : '' } });
    }
    if (t.matches('[data-lm-note]')) update({ note: t.value });
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeAll();
    if (e.key === 'Enter' && e.target.matches('[data-lm-code] input')) { e.preventDefault(); const v = e.target.value.trim(); if (v) applyCode(v); }
  });

  /* Horizon / uygulama sepet olayları geldiğinde çekmeceyi tazele */
  ['cart:update', 'cart:refresh'].forEach((ev) => document.addEventListener(ev, () => refresh().catch(() => {})));
  window.addEventListener('pageshow', (e) => { if (e.persisted) refresh().catch(() => {}); });

  /* ---------- header: duyuru döngüsü + yükseklik ---------- */
  function initHeader() {
    $$('[data-lm-announce]').forEach((box) => {
      const track = box.querySelector('.lm-announce__track');
      const n = track ? track.children.length : 0;
      if (n < 2) return;
      const speed = (+box.dataset.speed || 4) * 1000;
      let i = 0;
      setInterval(() => { i = (i + 1) % n; track.style.transform = `translateY(-${i * box.offsetHeight}px)`; }, speed);
    });
    const h = $('.lm-header-wrap');
    if (h) {
      const set = () => {
        const a = h.querySelector('.lm-announce');
        const ah = a ? a.offsetHeight : 0;
        document.body.style.setProperty('--lm-announce-h', ah + 'px');
        document.body.style.setProperty('--lm-header-h', (h.classList.contains('is-sticky') ? h.offsetHeight - ah : 0) + 'px');
        document.body.style.setProperty('--header-height', h.offsetHeight + 'px');
        document.body.style.setProperty('--header-group-height', '0px');
      };
      set(); window.addEventListener('resize', set, { passive: true });
    }
    fillDelivery();
    fillRecs($('#lm-drawer') || document);
    if (location.hash === '#sepet') setTimeout(openDrawer, 300);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initHeader); else initHeader();

  window.LM = { money, toast, recs, closeAll, openDrawer, openModal, openLayer, delivery, fillDelivery, cfg: CFG, cart: { add, change, update, refresh } };
})();
